<template>
  <div class="content-section active" id="user-management">
    <div class="admin-header">
      <div>
        <h1 class="admin-title">用户管理</h1>
        <p>管理注册用户信息与账户状态</p>
      </div>
      <div class="admin-actions">
        <button class="admin-btn secondary" @click="addUser">
          <i class="fas fa-user-plus"></i> 添加用户
        </button>
        <button class="admin-btn" @click="freshUser">
          <i class="fas fa-sync-alt"></i> 刷新数据
        </button>
      </div>
    </div>
    
    <div class="role-tabs">
      <div 
        class="role-tab" 
        :class="{ active: activeRole === 'all' }"
        @click="changeRole('all')"
      >
        全部用户
      </div>
      <div 
        class="role-tab" 
        :class="{ active: activeRole === 'edu' }"
        @click="changeRole('edu')"
      >
        教育用户
      </div>
      <div 
        class="role-tab" 
        :class="{ active: activeRole === 'sound' }"
        @click="changeRole('sound')"
      >
        音疗用户
      </div>
<!--      <div 
        class="role-tab" 
        :class="{ active: activeRole === 'admin' }"
        @click="changeRole('admin')"
      >
        管理员
      </div>-->
    </div>
    
    <div class="data-table-container">
      <div class="table-controls">
        <div class="search-box">
          <i class="fas fa-search"></i>
          <input 
            type="text" 
            @input="handleSearch"
            id="user-search-input" 
            placeholder="搜索用户名、邮箱或手机号..."
            v-model="searchText"
          >
        </div>
        <div class="filters">
          <select class="filter-select" v-model="filters.status">
            <option value="all">全部状态</option>
            <option value="create">待处理</option>
            <option value="contacted">已联系</option>
            <option value="rejected">已拒绝</option>
          </select>
          <select class="filter-select" v-model="filters.date">
              <option value="all">提交时间：全部</option>
              <option value="30">最近30天</option>
              <option value="7">最近7天</option>
          </select>
        </div>
      </div>
      
      <table class="data-table">
        <thead>
          <tr>
            <th>用户信息</th>
            <th>类型</th>
            <th>联系方式</th>
            <th>提交预约时间</th>
            <th>状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="user in filteredUsers" 
            :key="user.id"
            :data-role="user.resvType"
            :data-status="user.state"
            :data-date="user.submit_time"
          >
            <td>
              <div class="user-info">
                <div class="user-avatar">{{ user.name.charAt(0) }}</div>
                <div>
                  <div class="user-name">{{ user.name }}</div>
                  <div>{{ user.email }}</div>
                </div>
              </div>
            </td>
            <td>{{ getRoleText(user.resvType) }}</td>
            <td>{{ user.phone }}</td>
            <td>{{ user.submit_time }}</td>
            <td>
                <span :class="['status-badge', user.state]">
                    {{ getStatusText(user.state) }}
                </span>
            </td>
            <td>
              <button class="action-btn edit-user-btn" @click="editUser(user)">
                <i class="fas fa-edit"></i> 编辑
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      
      <div class="pagination">
        <button 
          class="pagination-btn" 
          :disabled="currentPage === 1"
          @click="prevPage"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
        <button 
          v-for="page in totalPages" 
          :key="page"
          class="pagination-btn" 
          :class="{ active: currentPage === page }"
          @click="goToPage(page)"
        >
          {{ page }}
        </button>
        <button 
          class="pagination-btn" 
          :disabled="currentPage === totalPages"
          @click="nextPage"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios';
    import { EventBus } from '@/eventBus.js';
export default {
  name: 'UserManagement',
  data() {
    return {
        timeout_fd: null,
      activeRole: 'all',
      searchText: '',
      filters: {
        status: 'all',
        date: 'all'
      },
      currentPage: 1,
      pageSize: 10,
      totalItems: 128,
      users: [
        {
          id: 'u1',
          name: '王老师',
          email: 'wanglaoshi@example.com',
          phone: '138****1234',
              resvType: 'edu',
              submit_time: '2025-05-10',
          experienceTime: '2025-06-19 09:30',
              state: 'contacted',
          position: '教师',
              organization: '阳光中学'
        },
        {
          id: 'u2',
          name: '张经理',
          email: 'zhang@company.com',
          phone: '139****5678',
            resvType: 'sound',
            submit_time: '2025-06-01',
          experienceTime: '2025-06-18 15:45',
            state: 'create',
          position: '人力资源总监',
            organization: '科技发展公司'
        },
        {
          id: 'u3',
          name: '李管理员',
          email: 'admin@shixinai.com',
          phone: '137****0000',
            resvType: 'admin',
            submit_time: '2025-01-15',
          experienceTime: null,
            state: 'active',
          position: '系统管理员'
        },
        {
          id: 'u4',
          name: '陈医生',
          email: 'chen@hospital.com',
          phone: '136****9999',
            resvType: 'sound',
            submit_time: '2025-05-20',
          experienceTime: '2025-06-25 14:00',
            state: 'confirmed',
          position: '心理科主任',
            organization: '人民医院'
        },
        {
          id: 'u5',
          name: '刘家长',
          email: 'liu@parent.com',
          phone: '135****8888',
            resvType: 'edu',
            submit_time: '2025-06-15',
          experienceTime: null,
            state: 'create',
          position: '家长',
            organization: '实验小学'
        }
      ]
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },
    filteredUsers() {
      let filtered = this.users;
      
      // 角色过滤
      if (this.activeRole !== 'all') {
          filtered = filtered.filter(user => user.resvType === this.activeRole);
      }
      
      // 搜索过滤
      if (this.searchText) {
        const search = this.searchText.toLowerCase();
        filtered = filtered.filter(user => 
          user.name.toLowerCase().includes(search) ||
          user.email.toLowerCase().includes(search) ||
          user.phone.includes(search)
        );
      }
      
      // 状态过滤
      if (this.filters.status !== 'all') {
          filtered = filtered.filter(user => user.state === this.filters.status);
      }
      
      
      return filtered;
    }
        },

        created() {
            this.resetParam();
            this.getUserList();
        },
        mounted() {
            EventBus.$on('freshUserList', () => {
                this.getUserList();
            });
        },
        beforeDestroy() {
            EventBus.$off('freshUserList');
        },
methods: {
    resetParam() {
        this.users = [];
        this.searchText = null;
        
        this.filters = {
            status: 'all',
            date: 'all'
        };
        this.currentPage = 1;
        this.totalItems = 0;
    },

    async getSearchList() {
        const isInExpired = await this.$store.dispatch('isInExpired');
        if (!isInExpired) {
            this.$message({
                message: "登录已过期，请重新登录",
                type: "error",
            });
            return;
        }
        const token = localStorage.getItem('token');
        try {
            const payload = {
                curpage: this.currentPage,
                search: this.searchText,
            };
            const response = await axios.post('/api/reservation/search', payload, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.status !== 200) {
                this.$message({
                    message: "网络异常，请稍后尝试",
                    type: "error",
                });
                console.error(response.status);
                return;
            }
            if (response.data.code !== "00") {
                this.$message({
                    message: response.data.message,
                    type: "error",
                });
                return;
            }
            console.log(response.data.infos);
            this.users = response.data.infos;
            this.totalItems = response.data.total;
        } catch (error) {
            console.error(' failed:', error);
            this.$message({
                message: "网络异常，请稍后尝试",
                type: "error",
            });
        }
    },
    handleSearch() {
        clearTimeout(this.timeout_fd);
        this.timeout_fd = setTimeout(() => {
            if (this.searchText.length > 0) {
                this.getSearchList();
            } else {
                this.getUserList();
            }
        }, 1000);
    },
    async getUserList() {
        const isInExpired = await this.$store.dispatch('isInExpired');
        if (!isInExpired) {
            this.$message({
                message: "登录已过期，请重新登录",
                type: "error",
            });
            return;
        }
        const token = localStorage.getItem('token');
        try {
            let payload = {};
            if (this.activeRole === 'all') {
                payload = {
                    curpage: this.currentPage,
                };
            } else {
                payload = {
                    resvType: this.activeRole,
                    curpage: this.currentPage,
                };
            }
            const response = await axios.post('/api/reservation/list', payload, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.status !== 200) {
                this.$message({
                    message: "网络异常，请稍后尝试",
                    type: "error",
                });
                console.error(response.status);
                return;
            }
            if (response.data.code !== "00") {
                this.$message({
                    message: response.data.message,
                    type: "error",
                });
                return;
            }
            this.users = response.data.infos;
            this.totalItems = response.data.total;
        } catch (error) {
            console.error(' failed:', error);
            this.$message({
                message: "网络异常，请稍后尝试",
                type: "error",
            });
        }
    },
    changeRole(role) {
        if (this.activeRole == role) {
            return;
        }
        this.activeRole = role;
        this.getUserList();
    },
    getRoleText(role) {
      const roleMap = {
        'edu': '教育用户',
        'sound': '音疗用户',
        'admin': '管理员'
      };
      return roleMap[role] || role;
    },
    getStatusText(status) {
      const statusMap = {
        'create': '待处理',
        'contacted': '已联系',
        'rejected': '已拒绝',
      };
      return statusMap[status] || status;
    },
    editUser(user) {
      this.$emit('edit-user', user);
    },
    prevPage() {
      if (this.currentPage > 1) {
          this.currentPage--;
          if (this.searchText.length > 0) {
              this.getSearchList();
          } else {
              this.getUserList();
          }
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
          this.currentPage++;
          if (this.searchText.length > 0) {
              this.getSearchList();
          } else {
              this.getUserList();
          }
      }
    },
    goToPage(page) {
        if (this.currentPage !== page) {
            this.currentPage = page;
            if (this.searchText.length > 0) {
                this.getSearchList();
            } else {
                this.getUserList();
            }
        }
      },
    async freshUser() {
        this.$emit('freshShow');
        try {
            await this.getUserList();            
        } finally {
            this.$emit('freshEnd');
        }
    },
    addUser() {
        this.$emit('show-add-user');
    },
  }
}
</script>